import React from 'react';
import Tabs from '@boschebike/ebds-react/dist-esm/components/Tabs.js';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';

/**
 * @typedef {import('../../App.d.ts').TermsOfUseTabsProps} TermsOfUseTabsProps
 */
/**
 * @param {TermsOfUseTabsProps} props
 */
export default ({ tabs, active }) => {
  return (
    <Container>
      <Tabs
        activeId={active}
        onChange={(id) => {
          window.location.href = `/${id}`;
        }}
        standout={false}
      >
        <Tabs.Navigation>
          {tabs.map((t) => (
            <Tabs.NavigationItem key={t.id} id={t.id}>
              {t.text}
            </Tabs.NavigationItem>
          ))}
        </Tabs.Navigation>
      </Tabs>
    </Container>
  );
};
